import { BlockCodeMirrorInnerField, LanguageMode } from '../CodeMirror/CodeMirror';
import { type ConfigFieldProps } from '../types';

interface DynamicFieldAutoValueProps extends ConfigFieldProps {
  fieldId: string;
}

export function DynamicFieldAutoValue(props: DynamicFieldAutoValueProps) {
  const { fieldId, fieldName } = props;
  return (
    <BlockCodeMirrorInnerField
      languageMode={LanguageMode.Expression}
      fieldId={fieldId}
      fieldName={`${fieldName}.jsonOrTemplate`}
      minHeight="unset"
      basicSetup={{ foldGutter: false, lineNumbers: false }}
      label="JSON or Template Value"
    />
  );
}
